import { sessionStore } from '@/common/utils/storage';
import { USERINFO_KEY } from '@/common/constant/storage-key';

export const state = () => ({
  userInfo: null,
});

export const mutations = {
  setUserInfo(state, data) {
    state.userInfo = data;
  },
};

export const actions = {
  async getUserInfo({ commit, dispatch }) {
    let res = sessionStore.get(USERINFO_KEY);

    // 缓存优化体验
    if (res) {
      commit('setUserInfo', res);
    }

    // 避免登录状态更新，每次都拉取
    await dispatch('fetchUserInfo');
  },

  async fetchUserInfo({ commit, dispatch }) {
    const res = await this.$service.auth.getAuthInfo().catch(() => null);
    if (res && res.userid) {
      // const [vipRes = {}, extRes = {}] = await Promise.all([
      //   this.$service.auth.getVipInfo(res.userid).catch(() => {}),
      //   this.$service.auth.getExtInfo().catch(() => {}),
      // ]);

      // res.vipInfo = vipRes;
      // res.extInfo = extRes;

      sessionStore.set(USERINFO_KEY, res);
      commit('setUserInfo', res);
    } else {
      // 未授权，调用退登相关
      dispatch('logout');
    }
  },

  logout({ commit }) {
    sessionStore.remove(USERINFO_KEY);
    commit('setUserInfo', null);
  },

  async login({ dispatch }) {
    await dispatch('fetchUserInfo');
  },
};
